import Al from "../../assets/images/flags/al.svg?react";

export default Al;
